import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useCart } from "../context/CartContext";
import {track,confirmPurchase} from '../analytics/service';

const API_BASE = process.env.REACT_APP_API_BASE_URL;

function getQueryParam(name) {
    const params = new URLSearchParams(window.location.search);
    return params.get(name);
}

export default function PayPalReturn() {
    const [status, setStatus] = useState("loading");
    const [error, setError] = useState("");
    const navigate = useNavigate();
    const { clearCart } = useCart();

    useEffect(() => {
        const token = getQueryParam("token");
        track('checkout_returned',{screen:'checkout_return',gateway:'paypal'},`paypal-return:${token}`);
        if (!token) {
            setStatus("error");
            setError("Token PayPal mancante.");
            return;
        }

        const tokenJwt = localStorage.getItem("token");

        (async () => {
            try {
                const res = await fetch(`${API_BASE}/api/paypal/capture-order`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: tokenJwt ? `Bearer ${tokenJwt}` : "",
                    },
                    body: JSON.stringify({ token }),
                });

                const data = await res.json().catch(() => ({}));
                if (!res.ok || !data.ok) {
                    throw new Error(data.error || "Errore nella conferma PayPal");
                }

                void confirmPurchase(token);
                try {
                    clearCart();
                } catch { }

                setStatus("success");
                navigate("/checkout/success?paypal=1", { replace: true });
            } catch (e) {
                setStatus("error");
                setError(e.message || "Errore nella conferma PayPal");
            }
        })();
    }, [navigate, clearCart]);

    if (status === "loading") {
        return <div style={{ padding: 24 }}>Conferma pagamento PayPal in corso…</div>;
    }

    if (status === "error") {
        return (
            <div style={{ padding: 24 }}>
                <h1>Errore PayPal</h1>
                <p>{error}</p>
            </div>
        );
    }

    return null;
}
